// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3nIYY","savePackageButton":"ClientWallet_savePackageButton__1J-9M"};